export default "__VITE_ASSET__BXHbOhBe__"